/**
 * 不同题目类型选项拥有的字段
 */

// 全部都有的字段
let basics = [
  'id',
  'title',
]

let choice = [
  'jumpTargetId',
  'settlementType',
  'settlementAmount',
  'settlementAmountRatio',
  'intelligentCall',
]

export default {
  info: [],
  text: [],
  multitext: [
    ...basics,
    'inputType',
    'inputMin',
    'inputMax',
    'required',
    'dataLabel',
  ].sort(),
  multiselect: [
    ...basics,
    ...choice,
    'mutexOptions',
    'dataLabel',
  ].sort(),
  imageMultiselect: [
    ...basics,
    ...choice,
    'mutexOptions',
    'images',
    'dataLabel',
  ].sort(),
  select: [
    ...basics,
    ...choice,
    'dataLabel',
    'exampleImages',
    'exampleText',
    'needEvidence',
    'localFile',
    'referIds',
    'nextSelectDelay',
    'autoIncreaseTaskGroupTarget',
    'takePhotoAuxiliaryLine',
    'priorityReview',
  ].sort(),
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert-fields/option-types.js